/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Taggroups_Genre1Inputs */

const id_search_taggroups_genre1 = /** @type {(inputs: Search_Taggroups_Genre1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genre`)
};

const ms_search_taggroups_genre1 = /** @type {(inputs: Search_Taggroups_Genre1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genre`)
};

const da_search_taggroups_genre1 = /** @type {(inputs: Search_Taggroups_Genre1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genre`)
};

const de_search_taggroups_genre1 = /** @type {(inputs: Search_Taggroups_Genre1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genre`)
};

const en_us2_search_taggroups_genre1 = /** @type {(inputs: Search_Taggroups_Genre1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genre`)
};

const es_es2_search_taggroups_genre1 = /** @type {(inputs: Search_Taggroups_Genre1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Género`)
};

const es_mx2_search_taggroups_genre1 = /** @type {(inputs: Search_Taggroups_Genre1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Género`)
};

const fil_search_taggroups_genre1 = /** @type {(inputs: Search_Taggroups_Genre1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genre`)
};

const fr_search_taggroups_genre1 = /** @type {(inputs: Search_Taggroups_Genre1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genre`)
};

const it_search_taggroups_genre1 = /** @type {(inputs: Search_Taggroups_Genre1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genere`)
};

const hu_search_taggroups_genre1 = /** @type {(inputs: Search_Taggroups_Genre1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Műfaj`)
};

const nl_search_taggroups_genre1 = /** @type {(inputs: Search_Taggroups_Genre1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genre`)
};

const no_search_taggroups_genre1 = /** @type {(inputs: Search_Taggroups_Genre1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sjanger`)
};

const pl_search_taggroups_genre1 = /** @type {(inputs: Search_Taggroups_Genre1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gatunek`)
};

const pt_br2_search_taggroups_genre1 = /** @type {(inputs: Search_Taggroups_Genre1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gênero`)
};

const pt_search_taggroups_genre1 = /** @type {(inputs: Search_Taggroups_Genre1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Género`)
};

const ro_search_taggroups_genre1 = /** @type {(inputs: Search_Taggroups_Genre1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gen`)
};

const fi_search_taggroups_genre1 = /** @type {(inputs: Search_Taggroups_Genre1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lajityyppi`)
};

const sv_search_taggroups_genre1 = /** @type {(inputs: Search_Taggroups_Genre1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Genre`)
};

const vi_search_taggroups_genre1 = /** @type {(inputs: Search_Taggroups_Genre1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thể loại`)
};

const tr_search_taggroups_genre1 = /** @type {(inputs: Search_Taggroups_Genre1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tür`)
};

const cs_search_taggroups_genre1 = /** @type {(inputs: Search_Taggroups_Genre1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žánr`)
};

const bg_search_taggroups_genre1 = /** @type {(inputs: Search_Taggroups_Genre1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жанр`)
};

const ru_search_taggroups_genre1 = /** @type {(inputs: Search_Taggroups_Genre1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жанр`)
};

const uk_search_taggroups_genre1 = /** @type {(inputs: Search_Taggroups_Genre1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Жанр`)
};

const ar_search_taggroups_genre1 = /** @type {(inputs: Search_Taggroups_Genre1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`النوع`)
};

const hi_search_taggroups_genre1 = /** @type {(inputs: Search_Taggroups_Genre1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`शैली`)
};

const th_search_taggroups_genre1 = /** @type {(inputs: Search_Taggroups_Genre1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`แนว`)
};

const ja_search_taggroups_genre1 = /** @type {(inputs: Search_Taggroups_Genre1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ジャンル`)
};

const zh_cn2_search_taggroups_genre1 = /** @type {(inputs: Search_Taggroups_Genre1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`类型`)
};

const zh_hant1_search_taggroups_genre1 = /** @type {(inputs: Search_Taggroups_Genre1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`類型`)
};

const ko_search_taggroups_genre1 = /** @type {(inputs: Search_Taggroups_Genre1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`장르`)
};

/**
* | output |
* | --- |
* | "Genre" |
*
* @param {Search_Taggroups_Genre1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_taggroups_genre1 = /** @type {((inputs?: Search_Taggroups_Genre1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Taggroups_Genre1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_taggroups_genre1(inputs)
	if (locale === "ms") return ms_search_taggroups_genre1(inputs)
	if (locale === "da") return da_search_taggroups_genre1(inputs)
	if (locale === "de") return de_search_taggroups_genre1(inputs)
	if (locale === "en-US") return en_us2_search_taggroups_genre1(inputs)
	if (locale === "es-ES") return es_es2_search_taggroups_genre1(inputs)
	if (locale === "es-MX") return es_mx2_search_taggroups_genre1(inputs)
	if (locale === "fil") return fil_search_taggroups_genre1(inputs)
	if (locale === "fr") return fr_search_taggroups_genre1(inputs)
	if (locale === "it") return it_search_taggroups_genre1(inputs)
	if (locale === "hu") return hu_search_taggroups_genre1(inputs)
	if (locale === "nl") return nl_search_taggroups_genre1(inputs)
	if (locale === "no") return no_search_taggroups_genre1(inputs)
	if (locale === "pl") return pl_search_taggroups_genre1(inputs)
	if (locale === "pt-BR") return pt_br2_search_taggroups_genre1(inputs)
	if (locale === "pt") return pt_search_taggroups_genre1(inputs)
	if (locale === "ro") return ro_search_taggroups_genre1(inputs)
	if (locale === "fi") return fi_search_taggroups_genre1(inputs)
	if (locale === "sv") return sv_search_taggroups_genre1(inputs)
	if (locale === "vi") return vi_search_taggroups_genre1(inputs)
	if (locale === "tr") return tr_search_taggroups_genre1(inputs)
	if (locale === "cs") return cs_search_taggroups_genre1(inputs)
	if (locale === "bg") return bg_search_taggroups_genre1(inputs)
	if (locale === "ru") return ru_search_taggroups_genre1(inputs)
	if (locale === "uk") return uk_search_taggroups_genre1(inputs)
	if (locale === "ar") return ar_search_taggroups_genre1(inputs)
	if (locale === "hi") return hi_search_taggroups_genre1(inputs)
	if (locale === "th") return th_search_taggroups_genre1(inputs)
	if (locale === "ja") return ja_search_taggroups_genre1(inputs)
	if (locale === "zh-CN") return zh_cn2_search_taggroups_genre1(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_taggroups_genre1(inputs)
	return ko_search_taggroups_genre1(inputs)
});
export { search_taggroups_genre1 as "search.tagGroups.genre" }